import { Typography } from "antd";
import React from "react";

const { Title } = Typography;

const PageTitle = ({ title, icon }) => (
  <Title
    level={3}
    style={{
      margin: 0,
      marginBottom: "24px",
      color: "#34495e",
      fontSize: "24px",
      fontWeight: 700,
      letterSpacing: "0.5px",
    }}
  >
    {icon &&
      React.cloneElement(icon, {
        size: 24,
        strokeWidth: 1.5,
        style: {
          marginRight: "12px",
          color: "#34495e",
          verticalAlign: "middle",
        },
      })}
    {title}
  </Title>
);

export default PageTitle;
